import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, effect, inject, input, output } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';

import { FormControl } from '@ngneat/reactive-forms';
import { TranslateModule } from '@ngx-translate/core';
import { skip } from 'rxjs';

import { ProviderIconComponent, SearchSelectComponent } from '@kr/components';
import { AvailableCompany } from '@kr/models';

@Component({
  selector: 'kr-company-selector',
  imports: [CommonModule, ReactiveFormsModule, TranslateModule, SearchSelectComponent, ProviderIconComponent],
  templateUrl: './company-selector.component.html',
  styleUrl: './company-selector.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompanySelectorComponent {
  readonly #destroyRef = inject(DestroyRef);

  selectedCompany = input.required<string>();
  companies = input.required<AvailableCompany[]>();
  changeEvent = output<string>();

  companyNameControl = new FormControl('');

  constructor() {
    this.companyNameControl.valueChanges.pipe(skip(1), takeUntilDestroyed(this.#destroyRef)).subscribe((value: string) => {
      if (value !== this.selectedCompany()) {
        this.changeEvent.emit(value);
      }
    });

    effect(() => this.companyNameControl.setValue(this.selectedCompany()));
  }
}
